import { CssBaseline } from '@mui/material';
import { RootContent } from 'RootContent';
import {
  AuthProvider,
  ConfirmDialogsProvider,
  CustomDateTimeProvider,
  GlobalStateProvider,
  LoggerProvider,
  OneSignalProvider,
  ReactQueryProvider,
  CommunityProvider,
  ApolloProvider,
  StreamChatProvider,
  LocalStorageProvider,
} from 'providers';
import { BrowserRouter } from 'react-router-dom';

import { InboxProvider } from 'providers/InboxProvider/InboxProvider';
import { HelpModal } from 'shared/components/dialogs';

import { NotificationsProvider } from './shared/features/notifications';

export default function App() {
  return (
    <LocalStorageProvider>
      <BrowserRouter>
        <LoggerProvider>
          <ApolloProvider>
            <OneSignalProvider>
              <CommunityProvider>
                <AuthProvider>
                  <StreamChatProvider>
                    <ConfirmDialogsProvider>
                      <CustomDateTimeProvider>
                        <CssBaseline />

                        <InboxProvider>
                          <GlobalStateProvider>
                            <HelpModal />

                            <NotificationsProvider>
                              <ReactQueryProvider>
                                <RootContent />
                              </ReactQueryProvider>
                            </NotificationsProvider>
                          </GlobalStateProvider>
                        </InboxProvider>
                      </CustomDateTimeProvider>
                    </ConfirmDialogsProvider>
                  </StreamChatProvider>
                </AuthProvider>
              </CommunityProvider>
            </OneSignalProvider>
          </ApolloProvider>
        </LoggerProvider>
      </BrowserRouter>
    </LocalStorageProvider>
  );
}
